module.exports = __webpack_public_path__ + "static/media/the-freedom-soup-twitter.54b371d5.jpg";